package com.oratakashi.web.pages

import androidx.compose.runtime.Composable
import com.oratakashi.web.components.layouts.PageLayout
import com.oratakashi.web.resources.R
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.style.vars.color.ColorVar
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Span

@Page
@Composable
fun HomePage() {
    val colorMode = ColorMode.current
    PageLayout("Home") {
        Column(
            modifier = it
                .display(DisplayStyle.Flex)
        ) {
            SpanText(
                text = R.string.HOME_TEXT_ENG,
                modifier = Modifier
                    .fontFamily(R.font.PoppinsRegular.name)
                    .fillMaxWidth()
            )

            Span(attrs = Modifier
                .padding(top = 0.8.cssRem)
                .display(DisplayStyle.Flex)
                .fontFamily(R.font.PoppinsMedium.name)
                .flexWrap(FlexWrap.Wrap)
                .toAttrs()
            ) {
                SpanText(
                    text = "Download my resume at ",
                    modifier = Modifier
                        .color(
                            if(colorMode.isLight) Color.black else Color.white
                        )
                        .fontFamily(R.font.PoppinsRegular.name)
                )
                Link(
                    path = "https://download.oratakashi.com/cv.pdf",
                    text = "https://download.oratakashi.com/cv.pdf",
                    modifier = Modifier.setVariable(ColorVar, R.colors.PRIMARY_500.value),
                    variant = UncoloredLinkVariant
                )
            }

            Span(attrs = Modifier
                .padding(top = 0.8.cssRem)
                .display(DisplayStyle.Flex)
                .fontFamily(R.font.PoppinsMedium.name)
                .flexWrap(FlexWrap.Wrap)
                .gap(0.5.cssRem)
                .toAttrs()
            ) {
                Link(
                    path = "https://www.linkedin.com/in/oratakashi/",
                    text = "#Linkedin",
                    modifier = Modifier.setVariable(ColorVar, R.colors.PRIMARY_500.value),
                    variant = UncoloredLinkVariant
                )

                Link(
                    path = "https://github.com/oratakashi",
                    text = "#Github",
                    modifier = Modifier
                        .setVariable(ColorVar, R.colors.PRIMARY_500.value),
                    variant = UncoloredLinkVariant
                )
            }
        }
    }
}


